import ListColumnModel from 'modules/base/model/list-column-model'
import { getCustomerKind } from './customer-list-model'

export default class CustomerListColumnModel extends ListColumnModel {
  constructor(data) {
    super(data)
    this.displayed = data.displayed
    this.hide = data.hide || false
    this.setColumnSpecificProperties()
  }

  setColumnSpecificProperties() {
    switch (this.name) {
      case 'discount': {
        this._reversed = true
        this.setCurrencyType()
        this.cellRenderer = 'amountCellRenderer'
        break
      }

      case 'totalSales':
        this.aggFunc = 'sum'
        this.setCurrencyType()
        break

      case 'balance': {
        this.setCurrencyType()
        this.sortable = false
        this.sort = false
        break
      }

      case 'kind': {
        this.valueFormatter = (params) => {
          return getCustomerKind(params.value)
        }
        this.filter = true
        this.setFilterParam({
          valueFormatter: (param) => {
            return getCustomerKind(param.value)
          },
          values: ['person', 'company'],
        })

        break
      }

      case 'tags': {
        this.setTagType()
        break
      }

      case 'phone': {
        this.cellClass = 'ExcelString'
        this.setFilterParam({ isOptional: true })
        break
      }
      case 'email':
      case 'street':
      case 'zipCode':
      case 'city':
      case 'mainContact':
      case 'category': {
        this.setFilterParam({ isOptional: true })
        break
      }

      default: { return }
    }
  }
}
